export default __webpack_public_path__ + "static/media/view-profile-outline-icon.c10385d1.svg";